import { observer } from 'mobx-react-lite';
import React, { useContext } from 'react';
import './App.css';
import AreaTree from './components/AreaTree';
import NodeContext from './providers/NodeProvider';

const App = observer(() => {
  const nodeContext = useContext(NodeContext);

  return (
    <div className='app'>
      <div>
        <h4>Overview:</h4> 
        <p><em>Slice & Anchor</em> is a UI Design App prototype rooted in a few ideas:</p>
        <ol>
          <li><strong><em>the box is already there</em></strong>: aka slice existing space vs. clicking and dragging to draw shapes</li>
            <ul>
              <li><small><em>In prototype</em></small></li>
            </ul>
          <li><strong><em>design-system first</em></strong>: aka the UI is a function of the design system (palette, fonts, type ramp, spacers, eases, controls, etc.)</li>
            <ul>
              <li><small><em>Not in prototype</em></small></li>
            </ul>
          <li><strong><em>anchor as rule not exception</em></strong>: aka the constructs rarely need to be absolutely positioned and are instead most often anchored or logically distributed</li>
            <ul>
              <li><small><em>Not in prototype</em></small></li>
            </ul>
        </ol>
      </div>
      <div>
        <h4>Controls:</h4>
        <ul>
          <li>Slice Horizontally: <em><strong>left click</strong></em></li>
          <li>Slice Vertically: <em><strong>right click</strong></em></li>
          <li>Remove Cell: <em><strong>alt + click</strong></em></li>
        </ul>
      </div>
      <div className='canvas'>
        <AreaTree
          node={nodeContext.nodeTree}
          hash={nodeContext.nodeHash}
          depth={0}
        />
      </div>
      <div>
        <h4><em>Debug</em>:</h4> 
        <p>Node count: {nodeContext.nodes.get().length}</p>
        <code>
          <pre>{JSON.stringify(Object.keys(nodeContext.nodeHash.get()))}</pre>
        </code>
        <hr />
        <code>
          <pre>{JSON.stringify(nodeContext.nodeHash.get(), undefined, 2)}</pre>
        </code>
      </div>
    </div>
  );
});

export default App;
